// import react
import React, { Suspense, lazy } from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import { observer } from 'mobx-react'
//import antd
import { Spin, ConfigProvider } from 'antd'
import enUS from 'antd/es/locale/en_US'
import zhCN from 'antd/es/locale/zh_CN'
import zhTW from 'antd/es/locale/zh_TW'
//import component
import Loading from '../components/Loading'
import MyModal from '../components/MyModal'

import UserInfoStore from '../store/UserInfoStore'
import GlobalControlStore from '../store/GlobalControlStore'

// import utils
import history from '../utils/history'
import { clearStore } from '../utils/clearStore'
import { logoutFetchHandler } from '../utils/fetchData'
import lang from '../i18n'

/*
  基于路由的代码分割
*/
const Enter = lazy(() => import('./Enter'))
const Welcome = lazy(() => import('./Welcome'))
const Workspace = lazy(() => import('./Workspace'))
const Analysis = lazy(() => import('./Analysis'))
const Payment = lazy(() => import('./Payment'))
const PayProcess = lazy(() => import('./PayProcess'))
const WeChat = lazy(() => import('./WeChat'))
const Test = lazy(() => import('./Test'))

/**
 * 这个组件是所有组件的根组件 也是根路由所在的地方 用户访问所有页面都要先渲染Home组件
 */

@observer
class Home extends React.Component {
  render() {
    let curLang = zhCN
    if (lang._curLang === 'us') {
      curLang = enUS
    } else if (lang._curLang === 'tw') {
      curLang = zhTW
    }
    return (
      <ConfigProvider locale={curLang}>
        <div
          className='Home-container'
          style={{ width: '100%', height: '100%' }}
        >
          <Router history={history}>
            <Suspense fallback={<Loading />}>
              <Switch>
                <Route exact path='/' render={() => <Enter />} />
                <Route path='/welcome' component={Welcome} />
                <Route path='/workspace' component={Workspace} />
                <Route path='/analysis' render={() => <Analysis />} />
                <Route path='/test' render={() => <Test />}></Route>
                <Route path='/wechat' render={() => <WeChat />}></Route>
                <Route path='/payment' render={() => <Payment />}></Route>
                <Route path='/process' component={PayProcess} />
                <Route path='/*' component={Workspace} />
              </Switch>
            </Suspense>
          </Router>
          {/* 全局loading */}
          <div
            className='Workspace-loading-container'
            style={{
              display: GlobalControlStore.showLoading ? 'block' : 'none',
            }}
          >
            <div className='Workspace-delete'>
              <Spin tip='Loading...'></Spin>
            </div>
          </div>
          {/* 全局提示仅提示不支持点击事件等 */}
          <div
            className='Workspace-loading-container'
            style={{
              display: GlobalControlStore.isShowTips ? 'block' : 'none',
            }}
          >
            <MyModal
              title={lang.lang('global.modalTitle')}
              content={GlobalControlStore.tipsContent}
              confirmText={lang.lang().tipsInfo.forSure}
              showCancel={false}
              confirmHandler={() => {
                GlobalControlStore.isShowTips = false
              }}
            />
          </div>
          {/* 全局登录失效提示 */}
          <div
            className='Workspace-loading-container'
            style={{
              display: GlobalControlStore.showLogoutTip ? 'block' : 'none',
            }}
          >
            <MyModal
              title={lang.lang('global.modalTitle')}
              content={lang.lang('global.loginInvalid')}
              confirmText={lang.lang().tipsInfo.forSure}
              cancelText={lang.lang().tipsInfo.cancel}
              showCancel={false}
              confirmHandler={() => {
                GlobalControlStore.showLoading = false
                GlobalControlStore.showLogoutTip = false
                UserInfoStore.logout = false
                UserInfoStore.login = false
                clearStore()
                history.push('/welcome')
              }}
            />
          </div>
          {/*退出弹窗*/}
          <div
            className='Workspace-delete'
            style={{
              height: UserInfoStore.logout ? '100%' : '0',
            }}
          >
            <div className='Workspace-logout-container'>
              <div className='Workspace-logout-title'>
                <div></div> {lang.lang('exitModal.tip')}
              </div>
              <div className='Workspace-logout-content'>
                {lang.lang('exitModal.confirm')}
              </div>
              <div className='Workspace-btn-container'>
                <div
                  className='Workspace-btn-item'
                  onClick={() => {
                    logoutFetchHandler(
                      () => {
                        UserInfoStore.logout = false
                        UserInfoStore.login = false
                        clearStore()
                        history.push('/welcome')
                      },
                      () => {},
                      () => {}
                    )
                  }}
                >
                  {lang.lang('exitModal.sure')}
                </div>
                <div
                  className='Workspace-btn-item Workspace-btn-item-right'
                  onClick={() => {
                    UserInfoStore.logout = false
                  }}
                >
                  {lang.lang('exitModal.cancel')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ConfigProvider>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/pages/Home.js